import { GrowinColors } from "@/colors";

/* eslint-disable */
const SignalDot = (props: any) => {
  const { cx, cy, payload } = props;

  if (!("signal" in payload) || payload["signal"] === "") return null;
  const signal = payload.signal;
  const color = GrowinColors[signal.startsWith("B") ? "rise" : "fall"];

  return (
    <svg x={cx - 12} y={cy - 36} width="25" height="42" viewBox="0 0 25 42">
      <g
        id="Group_15314"
        data-name="Group 15314"
        transform="translate(-355 -1892.25)"
      >
        <g id="Group_15316" data-name="Group 15316">
          <path
            id="Line_341"
            data-name="Line 341"
            d="M.5,10h-1V0h1Z"
            transform="translate(367.5 1916.25)"
            fill="#cfd3de"
          />
          <circle
            id="Ellipse_828"
            data-name="Ellipse 828"
            cx="12.5"
            cy="12.5"
            r="12.5"
            transform="translate(355 1892.25)"
            fill={color}
          />
          <circle
            id="Ellipse_829"
            data-name="Ellipse 829"
            cx="4.5"
            cy="4.5"
            r="4.5"
            transform="translate(363 1925.25)"
            fill={color}
          />
        </g>
      </g>
      <text
        x="25%"
        y="25%"
        dx=".7em"
        dy=".5em"
        textAnchor="middle"
        stroke="white"
        strokeWidth="1px"
        fontSize="10px"
        letterSpacing={0.8}
      >
        {signal}
      </text>
    </svg>
  );
};

export default SignalDot;
